import {Component, OnInit} from '@angular/core';
import {BodyContentModel} from "../../../../shared/model/body-content-model";
import {UrlType} from "../../../../shared/constants/url-type.enum";
import {API} from "../../../../shared/apis/api";
import {ActionBarType} from "../../../../shared/constants/action-bar-type.enum";
import {CooperativeAddComponent} from "../cooperative-add/cooperative-add.component";
import {CommonConstants} from "../../../../shared/constants/common-constants.enum";
import {StatusCodeLabels} from "../../../../shared/constants/status-code.enum";
import {ImportCooperativeComponent} from "../../../../shared/compoment/import-cooperative/import-cooperative.component";

@Component({
  selector: 'omni-cooperative-list',
  templateUrl: './cooperative-list.component.html',
  styleUrls: ['./cooperative-list.component.scss']
})
export class CooperativeListComponent implements OnInit {

  bodyContent: BodyContentModel;

  constructor() {
  }

  ngOnInit(): void {
    this.buildBodyContent();
  }

  private buildBodyContent() {
    const urlTypes = {
      [UrlType.DELETE]: {path: API.COOPERATIVE_DELETE}
    }
    this.bodyContent = {
      header: {
        title: 'Danh sách HTX'
      },
      searchArea: {
        box: true,
        placeholder: 'Tìm kiếm HTX'
      },
      actionBars: {
        buttonBarConfigs: [
          {actionBarType: ActionBarType.REFRESH}
        ],
      },
      tableConfig: {
        rowId: 'cooperativeNo',
        columnNameRouter: 'cooperativeNo',
        enableCheckbox: true,
        enableLink: true,
        columnData: CooperativeListComponent.buildCooperativeColumns(),
        urlStateParam: {path: API.COOPERATIVE_SEARCH},
        editUrl: '/meter-cooperative/cooperative/:routerId'
      },
      subActionBars: {
        addNewForm: CooperativeAddComponent,
        uploadForm: ImportCooperativeComponent,
        urlType: urlTypes,
        buttonBarConfigs: [
          {actionBarType: ActionBarType.NEW, customLabel: CommonConstants.CREATE_NEW_COOPERATIVE_LABEL},
          // {actionBarType: ActionBarType.UPLOAD, customLabel: CommonConstants.IMPORT_CUSTOMER_LABEL},
          {actionBarType: ActionBarType.DELETE, isRefreshNav: true}
        ],
        id: 'cooperative-list',
        deleteMessageNoRef: true
      },
    }
  }

  private static buildCooperativeColumns() {
    return [
      {
        name: 'Tên HTX',
        data: 'cooperativeName',
        type: 'link'
      },
      {
        name: 'Mã HTX',
        data: 'cooperativeCode'
      },
      {
        name: 'Ngày kết thúc',
        data: 'effectiveEndDate'
      },
      {
        name: 'Ngày chốt số',
        data: 'closingDate'
      },
      {
        name: 'Trạng thái',
        data: 'statusCode',
        enumType: StatusCodeLabels,
        type: 'status',
        orderable: false
      },
      {
        name: 'Tên tài khoản',
        data: 'userName',
        orderable: false
      },
      {
        name: 'Mật khẩu',
        data: 'rawPassword',
        type: 'password',
        orderable: false
      },
      {
        type: 'edit',
        editComponent: CooperativeAddComponent,
        orderable: false,
        initStateObject: 'cooperative',
      }
    ];
  }
}
